import { useState, type FC } from 'react'

import type { Action, DynamicActionsProps, FetchMethod } from '../types'
import { breakWords } from './FormDialog'
import { dynamicClient } from '@components/DynamicActions/hooks/useActionParams'
import { Button, Dialog, DialogContent, DialogHeader, DialogTitle } from '@fp/ui-kit'

interface ConfirmationDialogProps {
  action?: Action
  isOpen: boolean
  setIsOpen: (isOpened: boolean) => void
  onSuccess: DynamicActionsProps['onSuccess'] // (res?: ResponseData) => void
}

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({ action, isOpen, setIsOpen, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  if (!action || !action.confirm || !action.path) {
    return null
  }

  const { confirmation_message, name, path, method = 'GET', response_content_type } = action

  const onClose = () => setIsOpen(false)
  const onConfirm = async () => {
    setIsSubmitting(true)

    try {
      const res = await dynamicClient(method as FetchMethod, path, {}, response_content_type)

      if (res.type !== 'error') onSuccess?.(res, action)

      onClose()
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={isSubmitting ? undefined : setIsOpen}>
      <DialogContent aria-describedby={name} style={breakWords}>
        <DialogHeader>
          <DialogTitle className='text-center'>{name}</DialogTitle>
          <div className='flex flex-col gap-4 mt-4'>
            <div className='text-center'>{confirmation_message}</div>
            <div className='flex gap-2 justify-center'>
              <Button variant='primary' onClick={onConfirm} disabled={isSubmitting} isLoading={isSubmitting}>
                Confirm
              </Button>
              <Button onClick={onClose} disabled={isSubmitting}>
                Cancel
              </Button>
            </div>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
